// 20250719: xt/chtg converted the react-bootstrap to only bootstrap 5.3.3 
//         this way we can remove/uninstall react-bootstrap completely
import React from 'react'
import { connect } from 'react-redux'
import DatePicker from 'react-datepicker'
import { hideModal } from '../../actions/modal'
import { postUnitRoleAndShiftIncidentAssignment } from '../../actions/reportSummaries'
//import { Modal } from 'react-bootstrap'
import 'react-datepicker/dist/react-datepicker.css'
import './SelectStartDateModal.css'

const SelectStartDateModal = ({
  agency,
  incident,
  unitId,
  shiftId,
  roleId,
  reportSchemaId,
  dispatch,
  visible,
  languageCode
}) => {
  const hide = () => dispatch(hideModal())

  const saveSelection = (startDate) => {
    let date = Date.parse(startDate)
    const offset = new Date().getTimezoneOffset() * 60000
    date = date - offset

    dispatch(hideModal())
    dispatch(postUnitRoleAndShiftIncidentAssignment(incident, agency._id, reportSchemaId, unitId, roleId, shiftId, date))
  }

  // return (
  //   <Modal show={visible} onHide={hide} id='start-date-modal' dialogClassName='assignment-modal' backdrop>
  //     <Modal.Header closeButton closeLabel='Cancel'>
  //       <Modal.Title>Select Start Date</Modal.Title>
  //     </Modal.Header>
  //     <Modal.Body>
  //       <DatePicker
  //         inline
  //         onChange={saveSelection} />
  //     </Modal.Body>
  //   </Modal>
  // )

  return (
  visible && (
    <>
      <div
        className="modal fade show d-block"
        id="start-date-modal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog assignment-modal" role="document">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Select Start Date</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Cancel"
                onClick={hide}
              ></button>
            </div>

            <div className="modal-body">
              <DatePicker
                inline
                onChange={saveSelection}
              />
            </div>

          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  )
);

}

export default connect()(SelectStartDateModal)
